// function* loadClients(action) {
//   if (window.location.pathname !== '/clients') {
//     return ''
//   }
//
//   if (action.putToDb === false) {
//     return ''
//   }
//   const calendarId = yield select(getCalendarId)
//   const isUserAuth = yield select(isUserAuthorized)
//   if (undefined === calendarId) {
//     yield delay(500)
//     if (isUserAuth) {
//       yield* loadClients(action)
//     }
//     return
//   }
//
//   const clients = yield db.events
//     .where('calendarId')
//     .equals(calendarId)
//     .filter(e =>
//       !e.isDeleted && e.guest
//         ? Boolean(e.guest.name || e.guest.phone || e.guest.email)
//         : false,
//     )
//     .toArray()
//
//   yield Effects.put({
//     clients: clients
//       .map(e => ({
//         email: e.guest.email,
//         name: e.guest.name,
//         phone: e.guest.phone,
//       }))
//       .filter(
//         (client, index, self) =>
//           index ===
//           self.findIndex(
//             c =>
//               String(c.name).toLowerCase() ===
//                 String(client.name).toLowerCase() &&
//               c.phone === client.phone &&
//               String(c.email).toLowerCase() ===
//                 String(client.email).toLowerCase(),
//           ),
//       )
//       .map((c, i) => ({ ...c, id: i + 1 })),
//     type: ClientActions.PutClients,
//   })
// }

export default function* () {
  // yield Effects.takeLatest(ClientActions.GetClients, loadClients)
  // yield Effects.takeLatest('Events added to db', loadClients)
  // yield Effects.debounce(200, EventActions.EventWasDeleted, loadClients)
  // yield Effects.debounce(200, EventActions.EventWasUpdated, loadClients)
  // yield Effects.debounce(200, EventActions.DataForEventsAccepted, loadClients)
}
